import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as NotificationsActions from "../../../../store/notifications/notifications.actions";
import { AppState } from 'src/app/store/app.reducer';
import { Observable, Subscription } from 'rxjs';
import * as HomeActions from 'src/app/store/home/home.actions';
import { selectPermissionsTabIndex } from 'src/app/store/home/home.selector';

@Component({
	selector: 'app-permissions-tab-group',
	templateUrl: './permissions-tab-group.component.html',
	providers: [],
	styles: [`
		:host ::ng-deep .transparent-tabView .p-tabview-panels {
			background: transparent !important;
			padding-left: 0px;
			padding-right: 0px;
		}
	`]
})

export class PermissionsTabGroupComponent implements OnInit, OnDestroy {

	// Observables and subscriptions
	permissionsTabIndex$: Observable<number | undefined>;
	permissionsTabIndexSub: Subscription | undefined;

	permissionTabIndex: number;

	constructor(
		private store: Store<AppState>
	) {
		this.initSelectors();
	}


	initSelectors(): void {
		// Store selectors
		this.permissionsTabIndex$ = this.store.select(selectPermissionsTabIndex);
	}

	ngOnInit(): void {
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'PERMISSIONS'
		}));
		this.permissionsTabIndexSub = this.permissionsTabIndex$?.subscribe(
			async (supportTabIndex: number) => {
				this.permissionTabIndex = supportTabIndex;
			}
		);
	}

	ngOnDestroy(): void {
		this.permissionsTabIndexSub?.unsubscribe();
	}

	changeTab(e) {
		this.store.dispatch(HomeActions.selectPermissionsTab({ index: e.index }));
	}
}
